import { ContractInputAddress } from '../context/types';

/** Single-line "1 Bradley Road, Suite 801, Woodbridge, CT 06525" for display. */
export const formatAddressOneLine = (a: ContractInputAddress): string => {
  const stateZip = [a.region_code, a.postal_code].filter(Boolean).join(' ');
  return [a.address_line_1, a.address_line_2, a.locality, stateZip]
    .filter(s => s != null && s !== '')
    .join(', ');
};
